import styled from "styled-components";

const ProjectList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
  width: 100%;
`;

export { ProjectList };
